import { useQuery, gql } from '@apollo/client';

export const GET_ALL_PLATFORM_JOBS = gql`
  query getAllPlatformJobs {
    getAllPlatformJobs {
      _id
      companyId
      title
      activityKey
      jobLocations {
        _id
        companyLocationId
        companyBusinessAddressId
        companyDepartmentId
      }
      questionnaireSettingsIds
    }
  }
`;

export const useGetAllPlatformJobs = () => {
  const { data, loading } = useQuery(GET_ALL_PLATFORM_JOBS, { fetchPolicy: 'cache-and-network' });

  return {
    jobs: data?.getAllPlatformJobs || [],
    loading,
  };
};
